import { SystemFuncArgs } from '$legacyecstatic';
import Cursor from 'editor/components/Cursor';
import { Components } from '../components';
import DOMOverlay from '../components/DOMOverlay';

export const configureCursorComponents = [DOMOverlay, Cursor];

export function configureCursor(args: SystemFuncArgs<Components>): void {
  const { components } = args;

  const cursorComp = components.get(Cursor);
  const domOverlay = components.get(DOMOverlay);

  const container = domOverlay.domOverlay?.getContainer();

  if (!container) {
    return;
  }

  if (cursorComp.cursor !== cursorComp.prevCursor) {
    const parent = container.parentElement;
    if (parent) {
      parent.style.cursor = cursorComp.cursor;
      cursorComp.prevCursor = cursorComp.cursor;
    }
  }
}
